@if (tableConfig) {
  <app-ngb-table
    [config]="tableConfig"
    [data]="tableData"
    [sortingOrder]="sortingOrder || {}"
    [allSelected]="allPageSelected$ | async"
    (onSelectAll)="onSelectAll($event)"
    (onSort)="sortingRequested($event)"
  >
  </app-ngb-table>
}
